import React, { useState } from "react";
import { SketchPicker as ColorPicker } from "react-color";

import { OutlinedInput, ClickAwayListener } from "@material-ui/core";

import { rgbToHex, hexToRgb } from "../../../../utils";
import style from "../../style.module.css";

const ColorPickerField = (props) => {
  const { colorKey, getColorVal, setColor, label, colorPickerToolClassName } =
    props;

  const [isOpen, setOpen] = useState(false);
  // Val is the temporary value shown when the color picker drag is happening. This temporary
  // value is used instead of the main state to prevent spamming the iframe with color updates.
  const [val, setVal] = useState(null);

  const colorVal = rgbToHex(getColorVal(colorKey));

  return (
    <div className={style.fieldContainer} key={colorKey}>
      <div className={style.themeLabel}>
        {Array.isArray(label) && label.length > 0 ? label[0] : label}
      </div>
      <div className={style.themeLabelSecondary}>
        {Array.isArray(label) && label.length > 1 ? label[1] : null}
      </div>
      <ClickAwayListener onClickAway={() => setOpen(false)}>
        <div className={`${style.field} ${style.flexRow}`}>
          <div
            className={style.colorPickerButton}
            style={{
              backgroundColor: colorVal,
            }}
            onClick={() => setOpen(!isOpen)}
          />
          {isOpen ? (
            <div
              className={`${style.colorPickerTool} ${colorPickerToolClassName}`}
            >
              <ColorPicker
                color={val || colorVal}
                disableAlpha
                presetColors={[]}
                onChange={(cVal) => {
                  setVal(cVal.hex);
                }}
                onChangeComplete={(cVal) => {
                  setVal(null);
                  setColor(hexToRgb(cVal.hex));
                }}
              />
            </div>
          ) : null}
          <OutlinedInput
            className={style.input}
            readOnly
            value={colorVal}
            onClick={() => setOpen(!isOpen)}
          />
        </div>
      </ClickAwayListener>
    </div>
  );
};

export default ColorPickerField;
